<div class="flex flex-col p-4">
  <div class="flex flex-col lg:flex-row">
    <div class="eligible-voter-title" id="eligible-voters">Eligible Voters</div>
  </div>

  <!-- Filter by Location Section -->
  <div class="mt-4" *ngIf="isShowingLocations">
    <p class="text-[16px] leading-[21px]" id="filter-by-location">Filter by locations</p>
    <div class="flex items-center space-x-4">
      <label class="flex items-center space-x-2">
        <input
          type="radio"
          name="location"
          id="aus-nz"
          [(ngModel)]="selectedLocation"
          value="aus-nz"
          class="text-blue-600 form-radio"
          (change) = "filterByLocation()"
          checked
        />
        <span id="label-aus-nz">AUS & NZ</span>
      </label>
      <label class="flex items-center space-x-2">
        <input
          type="radio"
          name="location"
          id="aus"
          [(ngModel)]="selectedLocation"
          value="aus"
          class="text-blue-600 form-radio"
          (change) = "filterByLocation()"
        />
        <span id="label-aus">AUS</span>
      </label>
      <label class="flex items-center space-x-2">
        <input
          type="radio"
          name="location"
          id="nz"
          [(ngModel)]="selectedLocation"
          value="nz"
          class="text-blue-600 form-radio"
          (change) = "filterByLocation()"
        />
        <span id="label-nz">NZ</span>
      </label>
    </div>
  </div>

  <!-- Donut Chart Section -->
  <div class="mt-8">
    <app-donut-chart [data]="data" [ballotType] = 'ballotType' [showDecimalPlaces]="true"></app-donut-chart>
  </div>

  <app-sd-consensus-criteria *ngIf="isConsensusVisible" [data]="consensusData" (onConsensusChanged)="onConsensusChanged($event)" ></app-sd-consensus-criteria>

  <div class="flex flex-col p-4" *ngIf="isUserPmOrAboveOrHoSD && (isValidStatusGenerateReport || isFinaliseButtonVisible)">
    <hr class="w-full border-2 border-black">
    <div class="flex items-center justify-between mt-4">
      <button id="generateReportButton" class="w-auto h-[40px] btn body-default-regular btn-primary" mat-raised-button
        color="primary" (click)="generateSDBallotReport()">
        Generate Report
      </button>

      <button *ngIf="isFinaliseButtonVisible" id="finaliseBallotButton" class="btn btn-primary-blue"
        (click) = "onFinaliseBallotClicked()">
        Finalise Ballot
      </button>
    </div>
  </div>
</div>



